import FalconComponentCard from "components/common/FalconComponentCard";

const TaskTemplateExplanation = () => {
  return (
    <FalconComponentCard>
      <FalconComponentCard.Body>
        <p className="fw-bold">Template de Tarefas</p>
        <p className="fs-10">
          Um template de tarefas permite criar modelos pré-definidos de
          atividades que podem ser reutilizados em diferentes projetos ou
          solicitações de serviço. Você pode definir templates com sequências
          de tarefas organizadas, incluindo títulos de grupos, descrições
          detalhadas e prazos específicos. Cada template pode ser associado
          a subcategorias de serviço específicas e clientes, garantindo que
          apenas as equipes apropriadas tenham acesso aos modelos relevantes.
        </p>
        <br />

        <p className="fw-bold">Associação Manual</p>
        <p className="fs-10">
          Para criar um template de tarefa de associação manual desmarque
          o switch "Todos os clientes" e não marque a checkbox de nenhum
          cliente listado.
        </p>
        <br />

        <p className="fw-bold">Prazos e Estrutura</p>
        <p className="fs-10">
          As tarefas dentro de um template podem ser organizadas de forma
          hierárquica utilizando títulos de grupo, permitindo dividir as
          atividades em blocos lógicos. Cada tarefa pode conter uma descrição
          detalhada, prazo (em dias corridos) e ser atribuída a agentes específicos,
          garantindo clareza sobre responsabilidades e etapas do processo.
        </p>
        <br />

        <p className="fw-bold">Reutilização e Padronização</p>
        <p className="fs-10">
          Os templates promovem a padronização dos processos, garantindo
          que todas as etapas importantes sejam seguidas consistentemente.
          Quando um novo projeto é iniciado, você pode aplicar um template
          existente, economizando tempo na criação manual de tarefas e
          reduzindo a possibilidade de omissões. Os templates também
          facilitam a estimativa de prazos e recursos necessários para
          projetos similares.
        </p>
        <br />

        <p className="fw-bold">Caso de Uso: Onboarding de Novo Colaborador</p>
        <p className="fs-10">
          O template "Onboarding de Novo Colaborador" padroniza e agiliza o processo de integração de novos funcionários, garantindo que todas as etapas sejam cumpridas com eficiência.
          <br />
          <strong>1. Criação do Template: </strong>
          O gestor de RH configura o template com título, descrição e associação a uma subcategoria (ex.: "RH &gt; Onboarding"). Ele pode aplicá-lo a toda a organização ou a clientes/departamentos específicos.
          <br />
          <strong>2. Estruturação das Tarefas: </strong>
          As tarefas são agrupadas em fases do processo:
          Pré-Admissão: Solicitar documentos, enviar proposta formal.
          Primeiro Dia: Criar e-mail corporativo, entregar equipamentos.
          Integração: Agendar treinamento, cadastrar no sistema de ponto.
          Cada tarefa tem responsável, prazo e descrição clara.
          <br />
          <strong>3. Associação com Clientes: </strong>
          O template pode ser liberado para todos os clientes ou apenas para grupos/departamentos específicos, conforme a necessidade.
          <br />
          <strong>4. Aplicação do Template: </strong>
          Ao contratar um novo colaborador, o RH aplica o template, e o sistema gera automaticamente todas as tarefas com seus respectivos responsáveis e prazos.
          <br />
          <strong>5. Benefícios: </strong>
          Garante padronização, reduz erros, facilita o acompanhamento, promove colaboração entre áreas (RH, TI, etc.) e melhora a experiência do novo colaborador.
        </p>
        <br />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
};

export default TaskTemplateExplanation;